import React from 'react';
import AppBar from '../../../commons/AppBar'
import ButtonsModules from '../../../commons/ButtonsModules';
import SiteMap  from '../../../commons/SiteMap';
import SpecificComponent from '../../../commons/SpecificComponent';
import { Grid } from '@material-ui/core';
import { TopButtons } from '../../../commons/TopButtons';
import FromServer from '../FromServer';
import BilantChartData from '../Components/BilantChartData';
import BackToTop from '../../../commons/BackToTop';

export default class Bilant extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
       bilantData:[],

        
        mapButtons:[{id:'financiarcontabil', label:'Inapoi Financiar', color:'#900DCB'},
        {id:'arf', label:'Analiza si raportare financiara (ARF)', color:'#900DCB'}
    ]
}
    }

     componentDidMount(){
      
         this.getBilantData()
    }

    goBack = (id) =>{
        this.props.history.push(`/${id}`)
    }

    getBilantData = async()=>{
        let fs = new FromServer();

        let getData = await fs.getEvaluare()

        // console.log('chartData2 :', chartData2);

        // console.log('chartData2 :', chartData2);

        // console.warn('listCapitole :', getData);

       if(getData.r){
        
        let bilant = getData.c.listCapitole.filter(c => c.capitol === 'Analiza cash flow')[0].categorii

        // console.warn('bilant', bilant)

        let myData = []

        for(let i = 0, n= bilant.length ; i < n ; i++){

            

            if(bilant[i].categorie === 'Fluxul de numerar'){
                myData.push(bilant[i].chartData[0])
            }else if(bilant[i].categorie === 'Analize profit si pierdere'){
                let dataToPush = bilant[i].chartData

                for(let k = 0 , n = dataToPush.length ; k<n ; k++ ){
                    myData.push(dataToPush[k])
                }
            }
        }

        // console.log('myData :', myData);
        // console.log('bilant :', bilant);

        this.setState({bilantData:myData})
       }
    }
     render() { 
       return (
          <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.financiar} />
              <BackToTop
                backToTop={this.backToTop}
                            />
                <ButtonsModules history={this.props.history}
                    scop={'Financiar'} />

        <div style={{textAlign:'left'}}>
            {this.state.mapButtons.map((b,idx)=>{
                return(
                    <SiteMap 
                        key={idx}
                        b={b}
                        buttonSelected={this.goBack} />
                        
                )
            })}
        </div>
        <h1 className='pm-title'>Bilant</h1>
            <div>
            {this.state.bilantData.map((b,idx)=>{

                if(b.chartData[0] === 0 && b.chartData[1] === 0){
                    return (
                        <div key={idx} style={{width:'45%', display:'inline-block'}}>
                            <h2 className='pm-title'>{b.titlu}</h2>
                            <h4 style={{color:'red', 
                                        letterSpacing:1,
                                        fontWeight:600 }}>Informatiile necesare acestui grafic nu au fost gasite in bilant / balanta</h4>

                        </div>
                    )
                }
                return(
 
                    
                        <BilantChartData
                            ch={b}
                            key={idx}
                        />
            
                )
            })}

            </div>
           
         </div>
        );
       }
}